import { CdkOverlayOrigin, ScrollStrategy, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { Component, Input } from '@angular/core';

import { TableColumnTypeEnum } from '../shared/enums';

/**
 * List of items displayed in <app-table>.
 * Can display a single text or a link.
 *
 * Display max 2 items at the same time.
 * If more than 2 items :
 * - Display one item
 * - Display a link "+ X others"
 * - Clicking the link opens a popover with all others items than the first one.
 */
@Component({
  selector: 'app-table-expandable-list',
  templateUrl: './table-expandable-list.component.html',
  styleUrls: ['./table-expandable-list.component.scss'],
})
export class TableExpandableListComponent {
  @Input() items: any[];
  @Input() column: any;

  TableColumnTypeEnum = TableColumnTypeEnum;

  popoverTrigger: CdkOverlayOrigin;
  scrollStrategy: ScrollStrategy;
  isPopoverOpened = false;

  constructor(private scrollStrategyOptions: ScrollStrategyOptions) {
    this.scrollStrategy = this.scrollStrategyOptions.close();
  }

  openPopover(popoverTrigger: CdkOverlayOrigin) {
    // can't put it in hard in HTML template, because the trigger is in a <ng-template>
    this.popoverTrigger = popoverTrigger;
    this.isPopoverOpened = !this.isPopoverOpened;
  }

  /**
   * When popover is closed via scroll, reset the state to hide the "close" link
   */
  closePopover() {
    this.isPopoverOpened = false;
  }
}
